import { ToastContainer, toast } from "react-toastify";
import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

import { getAdminAuthToken } from "../../../../auth/auth";
import { API_BASE_URL, base_url, profileImgSrc } from "../../../../config";
import Loader from "../../../../components/Loader";

import verifiedIcon from "../../../../assets/verified-icon.svg";
import notVerifiedIcon from "../../../../assets/not-verified-icon.svg";
import closeIcon from "../../../../assets/close-dialog-x.svg";

export default function ProfesionalsPage() {
  const dialogRef = useRef();
  const [isDeleting, setIsDeleting] = useState(false);
  const [selectedProffesional, setSelectedProffesional] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [filterText, setFilterText] = useState("");
  const [roleFilter, setRoleFilter] = useState("");
  const [availabilityFilter, setAvailabilityFilter] = useState("");
  const [proffesionals, setProffesionals] = useState("");
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });
  const token = getAdminAuthToken();

  const fetchProffesionals = async (
    filterText = "",
    roleFilter = "",
    availabilityFilter = "",
    page = 1
  ) => {
    setIsLoading(true);

    const queryParams = new URLSearchParams();
    if (filterText.trim()) queryParams.append("name", filterText);
    if (roleFilter.trim()) queryParams.append("role", roleFilter);
    if (availabilityFilter)
      queryParams.append("availability", availabilityFilter);
    queryParams.append("page", page);

    const response = await fetch(
      `${API_BASE_URL}/admin/employees/?${queryParams.toString()}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    const result = await response.json();

    if (result.success) {
      setProffesionals(result.data);
      setPagination(result.meta);
      setIsLoading(false);
    } else {
      setProffesionals([]);
      return { error: result.message || "Failed to fetch proffesionals" };
    }
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchProffesionals(filterText, roleFilter, availabilityFilter, page);
    }, 500);

    return () => clearTimeout(delay);
  }, [filterText, roleFilter, availabilityFilter, page]);

  const handleVerified = async (id, status) => {
    setIsDeleting(true);
    const data = {
      employee_id: id,
      verified: status,
    };

    const response = await fetch(
      `${API_BASE_URL}/admin/employees/update-verified`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );

    const result = await response.json();

    if (result.success === false) {
      setIsDeleting(false);
      toast.error("Failed to change verified status.");
      return { error: result.message || "Failed to change verified status." };
    }

    setProffesionals((prev) =>
      prev.map((curr) =>
        curr.id === id ? { ...curr, verified: parseInt(status) } : curr
      )
    );
    setIsDeleting(false);
    toast.success(result.message);
  };

  const handleOpenDialog = (id) => {
    dialogRef.current.showModal();
    setSelectedProffesional(id);
  };

  const handleCloseDialog = () => {
    dialogRef.current.close();
  };

  const handleDeleteProffesionals = async () => {
    dialogRef.current.close();
    setIsDeleting(true);

    try {
      const response = await fetch(`${API_BASE_URL}/admin/employees/trash`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ employee_id: selectedProffesional }),
      });

      const result = await response.json();

      if (!result.success) {
        toast.error(result.message);
        setIsDeleting(false);
        return;
      }

      setProffesionals((prev) =>
        prev.filter((curr) => curr.id !== selectedProffesional)
      );
      setIsDeleting(false);
      toast.success("Professional trashed successfully!");
    } catch (error) {
      console.error("Error trashing professional:", error);
      toast.error("Something went wrong.");
      setIsDeleting(false);
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <h2>Proffesionals</h2>
      <div className="select-candidate-filters-wrapper dash-filter-wrapper-all">
        <div className="dash-filter-wrapper-all__fields">
          <div className="dash-filter-wrapper-all__fields--search">
            <label>Filter by Name</label>
            <input
              type="search"
              placeholder="Search"
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
            ></input>
          </div>
          <div className="select-candidate__fields--select dash-filter-wrapper-all__fields--select">
            <div className="form-group">
              <label>Filter by Role</label>
              <input
                type="search"
                placeholder="Search"
                value={roleFilter}
                onChange={(e) => setRoleFilter(e.target.value)}
              ></input>
            </div>
          </div>
          <div className="select-candidate__fields--select dash-filter-wrapper-all__fields--select">
            <div className="form-group">
              <label>Availability</label>
              <select
                onChange={(e) => setAvailabilityFilter(e.target.value)}
                value={availabilityFilter}
              >
                <option value="">All</option>
                <option value="1">Available for work</option>
                <option value="0">Not available for work</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div className="dash-jobs-cards dash-card-wrapper">
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <div className="dash-cards-wrapper-inner dash-cards-wrapper-inner-proffesionals">
              <div className="job-card card-dash-all card-dash-all-first">
                <div className="job-card__name">
                  <p>Candidate Name</p>
                </div>
                <div className="job-card__name">
                  <p>Title</p>
                </div>
                <div className="job-card__email">
                  <p>Email</p>
                </div>
                <div className="job-card__status--profesional">
                  <p>Status</p>
                </div>
                <div className="job-card__verified--trash job-card__verified--trash--label">
                  <p>Verified</p>
                </div>
              </div>
              {proffesionals.length > 0 ? (
                proffesionals.map((curr) => (
                  <div className="job-card card-dash-all" key={curr.id}>
                    <div className="job-card__name dash-card__img--name">
                      <img
                        src={
                          curr.avatar === null
                            ? profileImgSrc
                            : `${base_url}${curr.avatar}`
                        }
                        alt="logo"
                      />
                      <div className="job-card__company-info">
                        <h4>{curr.name}</h4>
                      </div>
                    </div>
                    <div className="job-card__name">
                      <p>{curr.current_role}</p>
                    </div>
                    <div className="job-card__email">
                      <p>{curr.email}</p>
                    </div>
                    <div className="job-card__status-proffesionals">
                      <div className="candidates-all-single__availability">
                        {curr.status === 1 ? (
                          <>
                            <svg
                              width="8"
                              height="8"
                              viewBox="0 0 8 8"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle cx="4" cy="4" r="2" fill="#28DDCF" />
                              <circle
                                cx="4"
                                cy="4"
                                r="4"
                                fill="#28DDCF"
                                fillOpacity="0.2"
                              />
                            </svg>
                            Available For Work
                          </>
                        ) : (
                          <>
                            <svg
                              width="8"
                              height="8"
                              viewBox="0 0 8 8"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle cx="4" cy="4" r="2" fill="#FF6633" />
                              <circle
                                cx="4"
                                cy="4"
                                r="4"
                                fill="#FF6633"
                                fillOpacity="0.2"
                              />
                            </svg>
                            Already Hired
                          </>
                        )}
                      </div>
                    </div>
                    <div className="job-card__verified--trash">
                      <div className="proffesional-is-verified">
                        <select
                          name="availability"
                          value={curr.verified}
                          onChange={(e) =>
                            handleVerified(curr.id, e.target.value)
                          }
                        >
                          <option value="0">Not Accepted</option>
                          <option value="1">Accepted</option>
                        </select>
                        {curr.verified === 1 ? (
                          <img src={verifiedIcon} alt="verified" />
                        ) : (
                          <img src={notVerifiedIcon} alt="not verified" />
                        )}
                      </div>
                      <div className="proffesional-edit-wrapper">
                        <button onClick={() => handleOpenDialog(curr.id)}>
                          <svg
                            width="12"
                            height="14"
                            viewBox="0 0 12 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M4.21593 5.97888C4.46927 5.95356 4.69516 6.13838 4.72048 6.39174L5.0278 9.46499C5.05319 9.71829 4.8683 9.94423 4.61501 9.96955C4.36167 9.99488 4.13576 9.81005 4.11043 9.55669L3.8031 6.48345C3.77777 6.23015 3.9626 6.00421 4.21593 5.97888Z"
                              fill="white"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M7.38257 5.97888C7.63587 6.00421 7.82069 6.23015 7.79537 6.48345L7.48804 9.55669C7.46272 9.81005 7.23684 9.99488 6.98348 9.96955C6.73018 9.94423 6.54536 9.71829 6.57068 9.46499L6.878 6.39174C6.90333 6.13838 7.12921 5.95356 7.38257 5.97888Z"
                              fill="white"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M4.64635 0.445324H6.72478C6.85779 0.445238 6.97366 0.445165 7.08306 0.462639C7.51535 0.531664 7.88942 0.801286 8.09158 1.18955C8.14278 1.28783 8.17935 1.39778 8.22133 1.52398L8.28993 1.72983C8.30155 1.76467 8.30486 1.77454 8.30769 1.78231C8.41532 2.07987 8.69437 2.28102 9.01073 2.28904C9.01902 2.28925 9.02923 2.28928 9.06611 2.28928H10.9101C11.1647 2.28928 11.371 2.49567 11.371 2.75027C11.371 3.00486 11.1647 3.21126 10.9101 3.21126H0.460987C0.206393 3.21126 0 3.00486 0 2.75027C0 2.49567 0.206393 2.28928 0.460987 2.28928H2.30499C2.34189 2.28928 2.35208 2.28925 2.3604 2.28904C2.67673 2.28102 2.95579 2.07989 3.06343 1.78232C3.06626 1.7745 3.06952 1.76485 3.08119 1.72983L3.14978 1.524C3.19176 1.3978 3.22834 1.28783 3.27952 1.18955C3.4817 0.801286 3.85577 0.531664 4.28806 0.462639C4.39748 0.445165 4.51335 0.445238 4.64635 0.445324ZM3.84657 2.28928C3.87823 2.22719 3.90629 2.16267 3.93042 2.09594C3.93775 2.07568 3.94494 2.05411 3.95417 2.0264L4.01552 1.84236C4.07156 1.67425 4.08446 1.63996 4.09726 1.61538C4.16465 1.48596 4.28935 1.39609 4.43344 1.37308C4.46081 1.36871 4.49741 1.36731 4.67462 1.36731H6.69651C6.87371 1.36731 6.91029 1.36871 6.9377 1.37308C7.08177 1.39609 7.20649 1.48596 7.27385 1.61538C7.28664 1.63996 7.29954 1.67424 7.3556 1.84236L7.41688 2.02629L7.44073 2.09595C7.46482 2.16267 7.49291 2.22719 7.52457 2.28928H3.84657Z"
                              fill="white"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M1.56706 4.44244C1.82109 4.42551 2.04075 4.61771 2.05769 4.87175L2.34039 9.11227C2.39562 9.94075 2.43497 10.5172 2.52138 10.9509C2.60518 11.3716 2.72217 11.5943 2.89023 11.7515C3.05828 11.9087 3.28826 12.0106 3.71359 12.0663C4.15208 12.1236 4.72987 12.1245 5.56014 12.1245H6.03551C6.86578 12.1245 7.44355 12.1236 7.88204 12.0663C8.30738 12.0106 8.53738 11.9087 8.70542 11.7515C8.87347 11.5943 8.9905 11.3716 9.07427 10.9509C9.16069 10.5172 9.20003 9.94075 9.25529 9.11227L9.53796 4.87175C9.55487 4.61771 9.77454 4.42551 10.0286 4.44244C10.2826 4.45938 10.4748 4.67904 10.4579 4.93308L10.173 9.20594C10.1205 9.99441 10.0781 10.6312 9.97849 11.131C9.87498 11.6506 9.69894 12.0846 9.33532 12.4247C8.97169 12.7649 8.52693 12.9117 8.00165 12.9804C7.49635 13.0465 6.85809 13.0465 6.0679 13.0465H5.52775C4.73756 13.0465 4.09927 13.0465 3.59401 12.9804C3.0687 12.9117 2.62397 12.7649 2.26035 12.4247C1.89672 12.0846 1.72067 11.6506 1.61717 11.131C1.51761 10.6312 1.47516 9.99441 1.42262 9.20594L1.13776 4.93308C1.12082 4.67904 1.31302 4.45938 1.56706 4.44244Z"
                              fill="white"
                            />
                          </svg>
                        </button>
                        <Link to={`/admin/candidates-profile/${curr.id}/edit`}>
                          <svg
                            width="11"
                            height="11"
                            viewBox="0 0 11 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5.85373 10.2944H9.2799M9.2799 1.44349C9.8712 2.03481 9.8712 2.99352 9.2799 3.58485L3.6431 9.22162C3.32184 9.54288 2.88611 9.72339 2.43177 9.72339H1.57103C1.25566 9.72339 1 9.46774 1 9.15236V8.29159C1 7.83728 1.18048 7.40153 1.50175 7.08027L7.13855 1.44349C7.72985 0.852169 8.6886 0.852169 9.2799 1.44349Z"
                              stroke="white"
                              strokeWidth="0.856542"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </Link>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No Candidate</p>
              )}
            </div>
            <div className="job-dashboard-pagination pagination-all">
              {Array.from(
                { length: pagination.last_page },
                (_, i) => i + 1
              ).map((num) => (
                <button
                  key={num}
                  className={num === pagination.current_page ? "active" : ""}
                  onClick={() => setPage(num)}
                >
                  {num}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
      <dialog ref={dialogRef} className="dialog-all">
        <button onClick={handleCloseDialog}>
          <img src={closeIcon} />
        </button>
        <h3>Are you sure you want to remove admin</h3>
        <p>
          This action will parentally delete admin access to this user without
          possibility to restore it
        </p>
        <div className="remove-admin-btn-group">
          <button onClick={handleCloseDialog}>Cancel</button>
          <button onClick={handleDeleteProffesionals}>Remove</button>
        </div>
      </dialog>
    </>
  );
}
